// Author YuJiaBei
// Date 2020-11-10 11:33:21

import * as model from "@/model/sithMes/prd/SithMesPrdOperationUserModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {customVuexFilterPatternFactory} from "@/store/em/commonPattern/customVuexFilterPatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesPrdOperationUser(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_PRD_URL,
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'andonUserFilter',
        filterInitializer: newFilter
    })
    .buildStore()
